import React, { useEffect, useState } from 'react';
import {
  INFO_TAB_LIST,
  RESTAURANT_EDIT,
  RESTAURANT_FILTER_TYPE_SUBMENU,
} from '../../../../../constants/restaurantConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_RESTAURANT,
} from '../../../../../constants/RoleConsts';
import MediaViewer from '../../../../../shared/media-viewer/MediaViewer';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import CustomView from '../../CustomView';
import ContactView from './Contact-View';
import { Details } from './Details';
import RestaurantHours from './RestaurantHours';
import LocationMap from '../../../../../shared/google-map/LocationMap';
import { allRestaurantSelector } from '../../../../property/propertySlice';
import { useSelector } from 'react-redux';
import { CtaView } from './Cta-View';
import { EMPTY_PLACEHOLDER } from '../../../../../utils/Constants';
import { decodeMediaKeyValue } from '../../../../../utils/mediaUtils';

const InfoView = (props) => {
  const { restaurantObj, onViewToggle, toggleDrawer, permissions } = props;
  const allRestaurantList = useSelector(allRestaurantSelector);
  const [restaurant, setRestaurant] = useState(null);
  const [restaurantDetails, setRestaurantDetails] = useState([]);
  const [ctaDetails, setCtaDetails] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const [commonDetails, setCommonDetails] = useState([]);
  const [isHeightIncluded, setIsHeightIncluded] = useState(false);

  useEffect(() => {
    if (allRestaurantList) {
      const currentRestaurant = allRestaurantList.find((resto) => resto.id === restaurantObj.id);
      setRestaurant(currentRestaurant);
    }
  }, [allRestaurantList]);

  const getTypeName = (type) => {
    const typeObj = RESTAURANT_FILTER_TYPE_SUBMENU.find(
      (restaurantType) => restaurantType.id === type,
    );
    if (typeObj) return typeObj.name;
    return '';
  };

  useEffect(() => {
    if (restaurant) {
      const details = [
        {
          id: 1,
          value1: restaurant.name,
          value2: restaurant.code,
          name1: 'Restaurant Name',
          name2: 'Restaurant Code',
        },
        {
          id: 2,
          value1: (() => {
            if (restaurant?.primaryCuisine) {
              const primary =
                restaurant?.primaryCuisine?.charAt(0)?.toUpperCase() +
                restaurant?.primaryCuisine?.slice(1);
              if (restaurant?.secondaryCuisine && restaurant?.secondaryCuisine?.length) {
                return [primary, ...restaurant.secondaryCuisine]
                  ?.map((elm) => elm?.charAt(0)?.toUpperCase() + elm?.slice(1))
                  ?.join(', ');
              }
              return primary;
            } else if (restaurant?.secondaryCuisine && restaurant?.secondaryCuisine?.length) {
              return restaurant.secondaryCuisine
                ?.map((elm) => elm?.charAt(0)?.toUpperCase() + elm?.slice(1))
                ?.join(', ');
            }
            return EMPTY_PLACEHOLDER;
          })(),
          value2: getTypeName(restaurant?.type),
          name1: 'Cuisine(s)',
          name2: 'Type',
        },
        {
          id: 3,
          value1: restaurant.description,
          name1: 'Description',
          type: 'full',
        },
        { id: 4, doc: restaurant.menu },
        { id: 5, customAttributes: restaurant.customAttributes || [] },
        { id: 6, status: restaurant.isActive },
        { id: 7, menuStatus: restaurant.menuStatus },
        { id: 8, ctaTitle: restaurant.ctaTitle },
        { id: 9, additionalMenu: restaurant.additionalMenu || [] },
      ];
      setRestaurantDetails(details);
    }
  }, [restaurant]);

  useEffect(() => {
    if (restaurant) {
      const details = [
        { id: 1, status: restaurant.cta?.status },
        { id: 2, ctaTitle: restaurant.cta?.ctaTitle },
        { id: 3, redirectOption: restaurant.cta?.redirectOption },
        { id: 4, redirectUrl: restaurant.cta?.redirectUrl },
      ];
      setCtaDetails(details);
    }
  }, [restaurant]);

  useEffect(() => {
    let details = [];
    if (tabValue === 2) {
      details = [
        {
          id: 1,
          value1: restaurant?.email,
          value2: restaurant?.contactNumber,
          name1: 'Email',
          name2: 'Phone Number',
        },
        { id: 2, information: restaurant?.contact },
      ];
    } else if (tabValue === 3) {
      details = [
        {
          id: 1,
          value1: restaurant?.location?.addressLine1,
          name1: 'Address Line 1',
        },
        {
          id: 2,
          value1: restaurant?.location?.addressLine2,
          name1: 'Address Line 2',
        },
        {
          id: 3,
          value1: restaurant?.location?.country,
          value2: restaurant?.location?.state,
          name1: 'Country',
          name2: 'State',
        },
        {
          id: 4,
          value1: restaurant?.location?.postalCode || EMPTY_PLACEHOLDER,
          value2: restaurant?.location?.city,
          name1: 'Postal Code',
          name2: 'City',
        },
        {
          id: 5,
          value1: restaurant?.location?.latitude || EMPTY_PLACEHOLDER,
          value2: restaurant?.location?.longitude || EMPTY_PLACEHOLDER,
          name1: 'Latitude',
          name2: 'Longitude',
        },
        {
          id: 6,
          value1: restaurant?.location?.area,
          value2: restaurant?.location?.timeZone || EMPTY_PLACEHOLDER,
          name1: 'Area',
          name2: 'Time Zone',
        },
      ];
    }
    setCommonDetails(details);
  }, [tabValue, restaurant]);

  const onOpenDrawer = (type) => {
    toggleDrawer(type, true, restaurant);
  };

  const handleTabChange = (event, newValue) => {
    setIsHeightIncluded(newValue === 0 ? false : true);
    setTabValue(newValue);
  };

  const renderScreen = () => {
    const { Video: videoMediaContent, GIF: gifMediaContent } = decodeMediaKeyValue(
      restaurant?.mediaContent,
    );
    const videoData = videoMediaContent || restaurant?.videos || {};
    const gifData = gifMediaContent || restaurant?.gifs || {};
    if (tabValue === 0 && restaurantDetails.length > 0)
      return <Details restaurantDetails={restaurantDetails} />;
    if (tabValue === 1) return <RestaurantHours restaurantHours={restaurant.hours} />;
    if (tabValue === 2) return <ContactView restaurantContact={commonDetails} />;
    if (tabValue === 3)
      return (
        <>
          {renderCommonView()}
          <div className='row mx-4 mt-4'>
            <div className='col-md-7'>
              <div className='details-label'>Google Maps</div>
              <div className='details-value'>
                <LocationMap
                  lat={restaurant?.location?.latitude}
                  lng={restaurant?.location?.longitude}
                />
              </div>
            </div>
          </div>
        </>
      );
    if (tabValue === 4) return <CtaView restaurantCta={ctaDetails} />;
    if (tabValue === 5)
      return (
        <div className='row pt-4 px-3'>
          <MediaViewer images={restaurant.images} videos={videoData} gifs={gifData} />
        </div>
      );
  };

  const renderCommonView = () => {
    if (commonDetails.length > 0) {
      return commonDetails.map((commonData) => (
        <CustomView
          key={commonData.id}
          value1={commonData.value1}
          value2={commonData.value2}
          name1={commonData.name1}
          name2={commonData.name2}
        />
      ));
    }
  };

  const onClickEdit = (event) => {
    onOpenDrawer(RESTAURANT_EDIT);
  };

  return (
    <>
      {restaurant && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          tabList={INFO_TAB_LIST}
          onViewToggle={onViewToggle}
          title={restaurant.name}
          createdUserId={restaurant.createdBy}
          isEditable={permissions[RBAC_TYPE_HOTEL_RESTAURANT] === RBAC_PERMISSION_LEVEL_FULL_ACCESS}
          tabClass='col-md-6'
          isHeightIncluded={isHeightIncluded}
        />
      )}
    </>
  );
};

export default InfoView;
